<div class="page-wrapper">
  <ion-content>
    <div class="content">
    <ion-header>
      <ion-toolbar class="toolbar-header">
        <ion-buttons slot="start" *ngIf="!isProfileUpdate">
          <ion-back-button  [defaultHref]="route"></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end" *ngIf="isProfileUpdate">
          <ion-button *ngIf="isProfileUpdate" (click)="modalCtrl.dismiss()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <div class="header">
        <figure>
          <img [src]="logoSquare" alt="logo" />
        </figure>
        <h2 [style.font-size.px]="screenHeight * 0.029" class="title">
          {{ isProfileUpdate || isManualVerification ? 'VERIFY' : 'CREATE ACCOUNT' }}
        </h2>
      </div>
    </ion-header>

    <div *ngIf="isManualVerification; else otpMode" class="content-wrapper-manual">
      <form [formGroup]="manualVerificationForm" (ngSubmit)="verify()">

        <ion-item class="input-item">
          <ion-input labelPlacement="floating" label="Email" type="email" formControlName="email" name="Email"
            required></ion-input>
        </ion-item>

        <ion-item class="input-item">
          <ion-input labelPlacement="floating" label="Code" type="text" inputmode="numeric" formControlName="code"
            name="Code" required></ion-input>
        </ion-item>

        <ion-footer>
          <ion-button expand="block" class="primary-button" type="submit">
            <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
            <span *ngIf="!isLoading">VERIFY</span>
          </ion-button>
          <div class="resend-code">
            <span>Didn't get a code?</span>
            <a href="javascript:void(0)" (click)="resendCode()" [class.disabled]="!canResend || isResending"
              [class.loading]="isResending">
              <span *ngIf="isResending">Sending...</span>
              <span *ngIf="!isResending && canResend">Resend the code</span>
              <span *ngIf="!isResending && !canResend">Resend in {{ getTimeString() }}</span>
            </a>
          </div>
          <ion-text color="primary" class="contact-link">
            <a (click)="gotoFeedback()">CONTACT US</a>
          </ion-text>
        </ion-footer>
      </form>
    </div>

    <ng-template #otpMode>
      <div class="content-wrapper">
        <div class="verification-container">
          <div class="verification-header">
            <h3>{{ getDisplayContact() }}</h3>
            <p>{{ getVerificationMessage() }}</p>
          </div>
          <div class="verification-content">
            <h4>ENTER CODE</h4>
            <form class="opt-form" (ngSubmit)="verify()">
              <ng-otp-input [config]="{
                  length: otpLength,
                  allowNumbersOnly: true,
                  inputStyles: {
                    width: '48px',
                    height: '48px',
                    margin: '0 5px',
                    borderRadius: '8px',
                    border: '1px solid var(--ion-color-dark)',
                    textAlign: 'center',
                    fontSize: '18px',
                    fontWeight: '600'
                  },
                  containerStyles: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '10px'
                  }
                }" (onInputChange)="onOtpChange($event)"></ng-otp-input>

              <div id="otp-instruction" class="sr-only">
                Enter the {{ otpLength }}-digit verification code. Use arrow keys to navigate between fields. Press
                Escape to clear all
                inputs.
              </div>
            </form>

            <div class="resend-code">
              <span>Didn't get a code?</span>
              <a href="javascript:void(0)" (click)="resendCode()" [class.disabled]="!canResend || isResending"
                [class.loading]="isResending">
                <span *ngIf="isResending">Sending...</span>
                <span *ngIf="!isResending && canResend">Resend the code</span>
                <span *ngIf="!isResending && !canResend">Resend in {{ getTimeString() }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <ion-footer>
        <ion-button expand="block" class="primary-button" type="submit" (click)="verify()">
          <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
          <span *ngIf="!isLoading">VERIFY</span>
        </ion-button>
      </ion-footer>
    </ng-template>
    </div>
  </ion-content>
</div>